import { Options, OrdersStatsResponse } from 'services/api';

import Company from './Company.service';

export default class Order extends Company {
  private static instance: Order;

  private constructor(options: Options) {
    /* istanbul ignore next */
    super(options);
    // this related to how typescript transpile this line in es5
    // e.g. var _this = _super.call(this) || this;
  }

  /**
   * This return the singleton instance of the class
   * @param {Options} options
   */
  public static getInstance(options: Options) {
    if (!this.instance) {
      this.instance = new this(options);
    }

    return this.instance;
  }

  /**
   * This returns the order stats of a company
   */
  getOrdersStats(params?: Record<string, any>) {
    const url = this.generateUrl('/company-portal/orders/stats');

    return this.makeRequest<OrdersStatsResponse>({
      url,
      method: this._request.Get,
      params: {
        ...params
      }
    });
  }
}
